<script setup lang="ts">
import { ref, watch, onUnmounted } from 'vue';
import { Close } from '@vicons/ionicons5';
import SignUp from './SignUp.vue';

const emit = defineEmits<{
    close: []
}>();

const show = ref(true);

const close = () => {
    const modal = document.querySelector('.mobile_modal_content') as HTMLElement;
    const overlay = document.querySelector('.mobile_modal_overlay') as HTMLElement;

    if (modal && overlay) {
        modal.style.animation = 'slideDown 0.3s ease-out';
        overlay.style.animation = 'fadeOut 0.3s ease-out';

        setTimeout(() => {
            show.value = false;
            document.body.style.overflow = 'auto';
            emit('close');
        }, 300);
    } else {
        show.value = false;
        document.body.style.overflow = 'auto';
        emit('close');
    }
};

const handleClickOutside = (event: Event) => {
    if (event.target === event.currentTarget) {
        close();
    }
};

// 初始化时锁定背景滚动
document.body.style.overflow = 'hidden';

// 组件卸载时恢复背景滚动
onUnmounted(() => {
    document.body.style.overflow = 'auto';
});
</script>

<template>
    <div v-if="show" class="mobile_modal_overlay" @click="handleClickOutside">
        <div class="mobile_modal_content">
            <div class="mobile_modal_header">
                <n-icon size="20" class="close-icon" @click="close">
                    <Close />
                </n-icon>
            </div>
            <div class="mobile_modal_body">
                <SignUp :key="'signup-' + show" @mobileClose="close" />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.mobile_modal_overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    backdrop-filter: blur(8px);
    z-index: 3000;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: env(safe-area-inset-bottom);
    animation: fadeIn 0.3s ease-out;
}

.mobile_modal_content {
    background: rgba(255, 255, 255, 0.99);
    border-radius: 24px 24px 0 0;
    width: 100%;
    max-width: 600px;
    height: 86vh;
    overflow: hidden;
    animation: slideUp 0.3s ease-out;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
}

.mobile_modal_header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.close-icon {

    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    color: rgb(5, 3, 3);
}

.close-icon:hover {
    background: rgba(0, 0, 0, 0.2);
    transform: scale(1.1);
}

.mobile_modal_body {
    padding: 0;
    min-height: 200px;
    color: #333;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    height: calc(100% - 65px);
    overflow-y: auto;
    width: 100%;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

@keyframes slideUp {
    from {
        transform: translateY(100%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slideDown {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(100%);
        opacity: 0;
    }
}
</style>